import logoText from './logo-text.svg';
import eye from './eye.svg';
import eyeOff from './eye-off.svg';
import logoTextWhite from './logoTextWhite.svg';
import playControlsIcon from './play_ic.svg';
import pauseControlsIcon from './pause_ic.svg';
import deleteIcon from './delete_ic.svg';
import homeActive from './homeActive.svg';
import usersTitleIcon from './users_title_icon.svg';
import checkGreenIcon from './check-green.svg';
import playCircleIcon from './play_circle_icon.svg';
import courseIcon from './course_ic.svg';
import closeModalIcon from './close_modal.svg';
import settingsTitleIcon from './settings_title_icon.svg';
import editIcon from './edit.svg';
import bookIc from './book_ic.svg';
import bookActiveIcon from './book_active_ic.svg';
import folderIc from './folder_ic.svg';
import folderIcEmpty from './folder_ic_empty.svg';
import dragIndicator from './drag_indicator.svg';
import folderArrow from './folders_arrow.svg';
import editorAddItemIc from './editor_add_item_ic.svg';
import arrowSupplementalIc from './arrow_supplemental_ic.svg';
import rotateIc from './rotate-ic.svg';
import lessonArrowBack from './lesson_arrow_back.svg';
import lessonArrowDown from './arrow_lesson_down.svg';
import lessonPlaceholderIc from './lesson_placeholder_ic.svg';
import numberPickerArrowUpIc from './number_picker_arrow_up.svg';
import numberPickerArrowDownIc from './number_picker_arrow_down.svg';
import alertTriangleIc from './alert-triangle.svg';
import lessonIc from './lesson_ic.svg';
import gradableIc from './gradable_ic.svg';
import editorInfoIc from './editor_info_ic.svg';
import supplementalArrowHistory from './supplemental_arrow_history.svg';
import fiftyPercentHistory from './50_percent_history.svg';
import editorVideoIcon from './editor_video_ic.svg';
import imageNodeIc from './image_node.svg';
import choiceBranchIc from './choice_branch.svg';
import textIc from './text_icon.svg';
import multipleChoiceListIc from './multiple_choice_list_ic.svg';
import gradableIconPlayer from './gradableIconPlayer.svg';
import infoPlayer from './info_player.svg';
import mChoiceModalIc from './mchoice_modal_icon.svg';
import mChoiceAnswerCorrect from './mchoice_answer_correct_ic.svg';
import mChoiceAnswerIncorrect from './mchoice_answer_incorrect_ic.svg';
import gradablePlayerIc from './gradable_player_ic.svg';
import lessonCompletedIc from './lesson_completed_ic.svg';
import lessonFailedIc from './lesson_failed_ic.svg';
import checkSuccessIc from './check_success_ic.svg';
import breadcrumbIc from './breadcrum_ic.svg';
import lessonListPlayButtonIc from './lesson_list_play_button_ic.svg';
import dividerWhiteIc from './divider_white_ic.svg';
import courseTimeIc from './course_time_ic.svg';
import courseDividerIc from './course_info_divider.svg';
import previewInfoIc from './preview_info.svg';
import editorAddAudio from './editor_add_audio.svg';
import editorAddGradableBranch from './editor_add_gradable_branch.svg';
import courseActionsTimeIc from './course_action_time_ic.svg';
import courseActionsLessonsIc from './course_action_lesson_icon.svg';
import aIassistantSmallIc from './ai_assistant_small_ic.svg';
import closeFilterIc from './close_filter_ic.svg';
import lessonsIcon from './lessons-icon.svg';
import notFoundIcon from './not_found_icon.svg';
import lessonBlocked from './lesson_blocked_ic.svg';
import jumpToIc from './jump_to.svg';
import freeformShapeIc from './freeform_shape.svg';
import acknowledgmentNodeIc from './ackowledgment_node.svg';
import loginBackground from './background_image.png';
import desktopIc from './descktop_icon.svg';
import copyIc from './copy_ic.svg';
import microreelCopyIc from './microreel_copy_ic.svg';
import subscriptionExpiredImage from './subscription_expired_image.png';
import edgeAddIc from './edge_add.svg';
import lightBulb from './light_bulb.svg';
import sampleTipImage from './sampleTipImageContent.svg';
import marketImage from './market_image.svg';
import aiMarketImg from './ai_market.svg';
import storageMarketImg from './storage_market.svg';
import learnersMarketImg from './learners_market.svg';
import instructorsMarkeImg from './instructors_market.svg';
import scormMarketImg from './scorm_market.svg';
import subAiIcon from './sub_ai_icon.svg';
import subStorageIc from './sub_storage_ic.svg';
import subUsersIc from './sub_users_ic.svg';
import subscriptionGreenCheck from './subscriotion_green_check.svg';
import subscriptionCrossIc from './subscription_cross_ic.svg';
import openFaq from './faq_open.svg';
import closeFaq from './close_faq.svg';
import subscriptionArrowBack from './subscription_summary_arrow_back.svg';
import subNavBarLogo from './logo.svg';
import aiChatIcon from './ai-chat-icon.svg';
import aiVideoIcon from './ai-video-icon.svg';
import voiceFemaleActive from './voice_female_active.svg';
import voiceFemaleInctive from './voice_female_inactive.svg';
import voiceMaleActive from './voice_male_active.svg';
import voiceMaleInactive from './voice_male_inactive.svg';
import aiAssistantLogo from './ai-assistant-logo.svg';
import aiAssistantLogoGreen from './ai-assistant-logo-green.svg';
import aiAssistantPlay from './ai-assistant-play-circle.svg';
import aiAssistantPause from './ai-assistant-pause-circle.svg';
import aiAssistantEmptyAvatar from './ai-assistant-empty-avatar.svg';
import libraryEmptyState from './library_empty_state.svg';
import imageStyle2dAmination from './image_style_2d_animation.png';
import imageStyle3dAnimation from './image_style_3d_animation.png';
import imageStyleChalkboardSketch from './image_style_chalkboard_sketch.png';
import imageStyleCinematicPhoto from './image_style_cinematic_photo.png';
import imageStyleVectorIllustration from './image_style_vector_illustration.png';
import videoAiProcessing from './video_ai_processing.svg';
import assistantPlaceholderIc from './assistant_placeholder_ic.svg';
import squareBackgorundImg from './square_background.svg';
import tooltipArrow from './tooltip_arrow.svg';
import analyticsEmptyState from './analytics_empty_state.svg';
// import openEndedQuestionIc from './open-ended-question-icon.svg';
const openEndedQuestionIc = 'open-ended-question-icon.svg'; // this is handled in Icon component as a special case for now
// temporary
import gradeIcon from './workspace_temporal_grade.svg';
import learnersIcon from './workspace_temporal_learners.svg';
import worldIcon from './workspace_temporal_world_icon.svg';
import videoIcon from './workspace_temporal_video.svg';
import UnpublishedEyeIcon from './workspace_temporal_unpublished_eye.svg';
import ImagePlaceholderIcon from './workspace_temporal_image_icon.svg';

import coursesEmptyState from './courses_empty_state.svg';
import learnerAssitantsEmptyState from './learner_assistans_empty_state.svg';
import cc_captions from './cc_captions.svg';
import check from './check.svg';
import music from './music.svg';
import audioIcon from './audio-icon.svg';
import recordVideoIcon from './record-video-icon.svg';
import examIcon from './exam-icon.svg';

// Tour
import libraryShowFilled from './library_show_filled.jpg';

export {
  aiMarketImg,
  storageMarketImg,
  learnersMarketImg,
  instructorsMarkeImg,
  scormMarketImg,
  subNavBarLogo,
  voiceFemaleActive,
  analyticsEmptyState,
  voiceFemaleInctive,
  voiceMaleActive,
  voiceMaleInactive,
  learnerAssitantsEmptyState,
  tooltipArrow,
  loginBackground,
  logoText,
  aiChatIcon,
  imageStyle2dAmination,
  imageStyle3dAnimation,
  imageStyleChalkboardSketch,
  imageStyleCinematicPhoto,
  imageStyleVectorIllustration,
  aiVideoIcon,
  subscriptionArrowBack,
  libraryEmptyState,
  videoAiProcessing,
  eye,
  openFaq,
  closeFaq,
  subAiIcon,
  subStorageIc,
  subUsersIc,
  eyeOff,
  logoTextWhite,
  playControlsIcon,
  pauseControlsIcon,
  subscriptionGreenCheck,
  deleteIcon,
  subscriptionCrossIc,
  lessonIc,
  homeActive,
  usersTitleIcon,
  checkGreenIcon,
  playCircleIcon,
  courseIcon,
  closeModalIcon,
  settingsTitleIcon,
  editIcon,
  bookIc,
  bookActiveIcon,
  folderIc,
  folderIcEmpty,
  dragIndicator,
  folderArrow,
  rotateIc,
  alertTriangleIc,
  arrowSupplementalIc,
  lessonArrowDown,
  editorAddItemIc,
  lessonArrowBack,
  closeFilterIc,
  gradableIc,
  editorInfoIc,
  supplementalArrowHistory,
  courseDividerIc,
  numberPickerArrowUpIc,
  numberPickerArrowDownIc,
  lessonPlaceholderIc,
  fiftyPercentHistory,
  editorVideoIcon,
  imageNodeIc,
  choiceBranchIc,
  textIc,
  subscriptionExpiredImage,
  multipleChoiceListIc,
  gradableIconPlayer,
  infoPlayer,
  mChoiceModalIc,
  mChoiceAnswerCorrect,
  mChoiceAnswerIncorrect,
  gradablePlayerIc,
  lessonCompletedIc,
  lessonFailedIc,
  checkSuccessIc,
  breadcrumbIc,
  lessonListPlayButtonIc,
  dividerWhiteIc,
  courseTimeIc,
  previewInfoIc,
  editorAddAudio,
  editorAddGradableBranch,
  courseActionsTimeIc,
  courseActionsLessonsIc,
  aIassistantSmallIc,
  lessonsIcon,
  desktopIc,
  notFoundIcon,
  lessonBlocked,
  copyIc,
  microreelCopyIc,
  jumpToIc,
  freeformShapeIc,
  acknowledgmentNodeIc,
  edgeAddIc,
  lightBulb,
  sampleTipImage,
  marketImage,
  aiAssistantLogo,
  aiAssistantLogoGreen,
  aiAssistantPlay,
  aiAssistantPause,
  assistantPlaceholderIc,
  aiAssistantEmptyAvatar,
  squareBackgorundImg,
  gradeIcon,
  learnersIcon,
  worldIcon,
  videoIcon,
  UnpublishedEyeIcon,
  ImagePlaceholderIcon,
  coursesEmptyState,
  openEndedQuestionIc,
  libraryShowFilled,
  cc_captions,
  check,
  music,
  audioIcon,
  recordVideoIcon,
  examIcon,
};
